//var $ = require('jquery');

import Indicator from '../data/IndicatorValueMap';




export function fetchData(value, params) {
   return dispatch => {
    dispatch(fetchDataBegin(value));
    return fetch(`https://kiiihr79w1.execute-api.us-east-1.amazonaws.com/dev/data?type=indicatorFilter&indicator=${Indicator[`${value}-tab`]}`) // TEST endpoint
    // return fetch(`https://l8set92mcj.execute-api.us-east-1.amazonaws.com/test/data?type=indicatorFilter&indicator=${Indicator[`${value}-tab`]}`) // PROD endpoint
          .then(handleErrors)
          .then(res => res.json())
          .then(json => {
            dispatch(fetchDataSuccess(json, params));
              return json;
            })
            .catch(error => dispatch(fetchDataFailure(error)));
          };
        }

function handleErrors(response) {
  if (!response.ok) {
    throw Error(response.statusText);
  }
  return response;
}

export const FETCH_DATA_BEGIN   = 'FETCH_DATA_BEGIN';
export const FETCH_DATA_SUCCESS = 'FETCH_DATA_SUCCESS';
export const FETCH_DATA_FAILURE = 'FETCH_DATA_FAILURE';

export const fetchDataBegin = indicator => ({
  type: FETCH_DATA_BEGIN,
  payload: indicator
});

export const fetchDataSuccess = (data, params) => ({
  type: FETCH_DATA_SUCCESS,
  params: params,
  payload: { data }
});

export const fetchDataFailure = error => ({
  type: FETCH_DATA_FAILURE,
  payload: { error }
});



// WEBPACK FOOTER //
// ./src/redux/StatsActions.js